/**
 * Centralized constants for Document Range permissions.
 * Follows the pattern: backoffice:document-range:{action}
 */
export const DOCUMENT_RANGE_PERMISSIONS = {
  VIEW: 'backoffice:document-range:view',
  CREATE: 'backoffice:document-range:create',
  UPDATE: 'backoffice:document-range:update',
  DELETE: 'backoffice:document-range:delete',
  VIEW_AUDIT_LOG: 'backoffice:document-range-audit-log:view',
  EXPORT: 'backoffice:document-range:export',
  TREE_VIEW: 'backoffice:document-range:tree-view',
} as const;

export type DocumentRangePermission = typeof DOCUMENT_RANGE_PERMISSIONS[keyof typeof DOCUMENT_RANGE_PERMISSIONS];
